import {Injectable} from '@angular/core';
import {ConfigInterface} from '../interfaces/configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: ConfigInterface;

  constructor() {
    this.config = (window as any).playerConfig;
  }

  public getConfig(): ConfigInterface {
    return this.config;
  }
}
